import $ from 'jquery';

export default class PageScroller {
    constructor() {
        window.addEventListener('scroll', () => {
            const hiddenScrollButton = window.pageYOffset < 100 ? 'true' : 'false';
            $('#scroll').attr('aria-hidden', hiddenScrollButton);
        });
        $('#scroll').click(() => {
            $("html, body").animate({ scrollTop: 0 }, 600);
            return false;
        });
    }
}
